<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="auto" class="pa-0">
        <p class="formTitle ma-0 pa-0">
          {{$t('datFormsTitles.files')}}
        </p>
      </v-col>
      <v-col cols="12">
        <v-data-table :headers="dTableHeaders" 
                      :items="dFiles"  
                      :item-key="dItemKey" 
                      :hide-default-footer="true"
                      :loading="dLoadingFiles" 
                      :noDataText="$t('datGeneric.noData')" 
                      :loading-text="$t('datGeneric.loading')" 
                      class="datTable"
                      >
          <!-- Imagen item -->
          <template v-slot:[`item.name`]="{ item }">
            <v-row class="ma-0" align-center>
              <v-col class="pa-1" cols="auto" >
                <file height="40"></file>
              </v-col>
              <span class="ml-2 mt-4">{{item.name}}</span>
            </v-row>
          </template>
          <!-- Fecha formateada -->
          <template v-slot:[`item.date`]="{ item }">
            <v-row class="ma-0">
              <v-col cols="auto" class="pa-0">
                <span class="mt-4">{{ fDateFormat(item.creationDate) }}</span>
              </v-col>
            </v-row>
          </template>
          <!-- Peso formateado -->
          <template v-slot:[`item.size`]="{ item }">
            <v-row class="ma-0">
              <v-col cols="auto" class="pa-0">
                <span class="mt-4">{{fShortSize(item.size)}}</span>
              </v-col>
            </v-row>
          </template> 
          <!-- Acciones -->
          <template v-slot:[`item.actions`]="{ item }">
            <!-- Botón de descarga de fichero original-->
            <v-tooltip v-if="item.url" bottom color="datSecondary">
              <template v-slot:activator="tooltip">
                <v-btn v-on="tooltip.on" @click="fDownloadFile(item)" icon>
                  <v-icon size="22" class="datPrimaryBtnIcon">mdi-file-outline</v-icon>
                </v-btn>
              </template>
              <span>{{$t('labels.download')}}</span>
            </v-tooltip>
            <v-btn v-if="!item.url" @click="fDeleteWarning(item)" icon>
              <v-icon size="22" class="datDeleteBtnIcon">mdi-delete</v-icon>
            </v-btn>
          </template>  
        </v-data-table>
      </v-col>                           
    </v-row>
  </div>
</template>
<script>

//Servicios y mixins
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'
import ServiceEcomplaints from '@/services/srv-eComplaints'
import ServiceEcomplaintsPublic from '@/services/srv-eComplaintsPublic'
import axios from 'axios'

//Componentes
import file from '@/assets/style/img/file'

export default {

  components: {
    file,
  },

  mixins: [mxCanalDenuncias],

  props: {
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    },
    pFiles:{
      type: Array,
      default: () => []
    },
    pTaskTitle:{
      type: String,
      default: null
    }
  },

  mounted(){
    this.dFiles = this.pFiles
  },

  data () {
    return {
      dExternalOrigin: localStorage.getItem("externOrigin"),
      dShowModal:false,
      dItemKey: 'name',
      dLoadingFiles: false,
      dFiles: [],
      dTableHeaders: [
        {
          text: this.$t('datTableHeader.name'),
          value: 'name',
          align: 'left',
          sortable: false,
          class: '',
        },{
          text: this.$t('datTableHeader.date'),
          value: 'date',
          align: 'left',
          sortable: false,
          class: '',
        },{
          text: this.$t('datTableHeader.size'),
          value: 'size',
          align: 'left',
          sortable: false,
          class: '',
        },{
          text: this.$t('datTableHeader.actions'),
          value: 'actions',
          align: 'center',
          sortable: false,
          class: '',
        }
      ],         
    }
  },
  methods: {

    // Modal de advertencia de borrado de fichero (Solo si está en modo edición de sobre)
    fDeleteWarning(item){
      if(item !== null){
        this.dSelectedItem = item
      }
      const alert = {
        text: this.$t('datAlert.deleteFile'),
        action: this.fDeleteItem,
        icon: 'mdi-delete-outline',
        type: 'error'
      }
      this.$bus.$emit('showAlert', alert)
    },
    
    // Elimina el fichero de la denuncia si ésta aun no ha sido guardada
    fDeleteItem(){
      this.dFiles.splice(this.dFiles.findIndex(data => data.name === this.dSelectedItem.name), 1)
    },

    fCreateFile(url, fileName){
      axios.get(url, { responseType: 'blob' }).then(blobResponse => {
        const blob = new Blob([blobResponse.data], { type: blobResponse.data.type })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        URL.revokeObjectURL(link.href)
        this.fSnackBarSuccess(this.$t('datAlert.savedFile'))
      }).catch(error => {
        console.log(error)
        this.fSnackbarError(this.$t('datError.downloadError'), this.pShowSnackbar)
      })
    },

    // Descarga el fichero seleccionado
    fDownloadFile(file){
      const payload = {
        complaintId: file.complaintId,
        name: file.name,
        taskTitle: this.pTaskTitle
      }
      
      if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.getFileUrl(payload).then(response => {
          if (response.statusCode === '200' && response.result !== 'ko'){
            const url= response.dataRes
            this.fCreateFile(url, file.name)
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }else{
        ServiceEcomplaints.getFileUrl(payload).then(response => {
          if (response.statusCode === '200' && response.result !== 'ko'){
            const url= response.dataRes
            this.fCreateFile(url, file.name)
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }
    }    
  },
  watch:{
    pFiles(){
      this.dFiles = this.pFiles
    },
    dFiles(){
      this.$emit('update', this.dFiles)
    }
  }
}
</script>